import { Modal } from 'ant-design-vue';
import { reactive, ref } from 'vue';
import { apiRoutes } from '../infraestructure/apiRoutes';
import { buildQueryParameters, get, post, softDelete, update } from '../infraestructure/repository/generic.repository';
import usePlant from "./usePlant";

const useBusinessUnit = () => {

  // ****************************************************************
  // ****************************************************************
  // VARIABLES INITIALIZATION

  // Paginator constants
  let paginatorTotalItems = ref(0)
  let paginatorTotalPages = ref(0)
  let paginatorCurrentPage = ref(0)

  const searchText = ref('')
  const visible = ref(false)
  const visiblePlants = ref(false)

  const formId = ref('')
  let form = reactive({
    code: '',
    name: '',
    status: true,
  })
  let formLoad = ref(false)
  const rules = {
    code: [{ required: true, message: 'El código de unidad de negocio es obligatorio' }],
    name: [{ required: true, message: 'El nombre de unidad de negocio es obligatorio' }],
  }

  // ERROR VARIABLES
  let errorHandler = reactive({
    errorDescription: {
      errors: [],
    },
    errorNumber: 0,
  })
  const ruleForm = ref(null)

  const businessUnits = ref([])
  const plants = ref([])

  const selectBusinessUnits = ref([])
  const tableLoading = ref(false)
  const plantsLoading = ref(false)
  // VARIABLES INITIALIZATION
  // ****************************************************************
  // ****************************************************************

  // ****************************************************************
  // ****************************************************************
  // MODAL FUNCTIONS
  const openPlantsModal = async (data = null) => {

    plantsLoading.value = true
    const { getPlantsNoPaginateByBusinessUnit } = usePlant()

    visiblePlants.value = true
    plants.value = await getPlantsNoPaginateByBusinessUnit(data.id)
    plantsLoading.value = false

  }

  const closePlantsModal = () => {
    visiblePlants.value = false
    plants.value = []
  }

  const openModal = (data = null) => {
    tableLoading.value = true
    visible.value = true
    if (formId.value !== '' && data) {
      const { code, name, status } = data
      form.code = code
      form.name = name
      form.status = status
    }
    tableLoading.value = false
  }
  const closeModal = () => {
    visible.value = false
    reinitializeForm()
  }
  const reinitializeForm = () => {
    formId.value = ''
    form.code = ''
    form.name = ''
    form.status = true

    errorHandler.errorDescription.errors = []
    errorHandler.errorNumber = 0
  }
  // MODAL FUNCTIONS
  // ****************************************************************
  // ****************************************************************

  // ****************************************************************
  // ****************************************************************
  // EVENTS FUNCTIONS
  const eventOpenPlantsModal = async (data) => {
    const { id } = data
    formId.value = id
    await openPlantsModal(data)
  }

  const eventOpenModal = (data) => {
    const { id } = data
    formId.value = id
    openModal(data)
  }

  const eventSoftDelete = (data) => {
    Modal.confirm({
      title: '¿Está seguro de eliminar este registro?',
      content: 'Está operación será irreversible, elija con precaución.',
      okText: 'Si, eliminar',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        tableLoading.value = true

        const { id } = data
        formId.value = id
        deleteRecord()
      },
      onCancel() {
      },
    })
  }
  // EVENTS FUNCTIONS
  // ****************************************************************
  // ****************************************************************

  const getBusinessUnitsNoPaginate = async (limit = 1000, page = 0) => {
    const path = `${apiRoutes.businessUnit}${buildQueryParameters(searchText, limit, page)}`
    const response = await get(path)
    const { items } = response.data
    selectBusinessUnits.value = items
  }

  const onChangePaginator = async (current) => {
    await getBusinessUnits(10, (current - 1))
  }

  const getBusinessUnits = async (limit = 10, page = 0) => {
    tableLoading.value = true

    const path = `${apiRoutes.businessUnit}${buildQueryParameters(searchText, limit, page)}`
    const response = await get(path)
    const { total, items, totalPages, currentPage } = response.data

    businessUnits.value = items
    paginatorTotalItems.value = total
    paginatorTotalPages.value = totalPages
    paginatorCurrentPage.value = (currentPage + 1)

    tableLoading.value = false
  }
  getBusinessUnits(10, 0)

  const submit = async () => {
    formLoad.value = true
    const path = apiRoutes.businessUnit

    if (formId.value !== '') {

      // Update
      await update(path, formId.value, form).then(() => {

        Modal.success({
          title: `¡El registro se ha actualizado exitosamente!`,
        })
        closeModal()
        formLoad.value = false

      }).catch((error) => {
        // It supports normalised or pure Axios errors
        const res = error?.response;
        const data = res?.data;

        let msgs = [];

        // 1) If it comes already normalized as Error with .message (without response)
        if (error?.message && !res) {
          msgs = [String(error.message)];
        } else if (Array.isArray(data?.message)) {
          msgs = data.message.map(m => String(m)).filter(Boolean);
        } else if (typeof data?.message === 'string') {
          msgs = [data.message];
        } else if (typeof data === 'string') {
          msgs = [data];
        }

        // Fallback if we couldn't extract anything
        if (!msgs.length) {
          const raw = error?.message || 'Ocurrió un error al procesar la solicitud.';
          msgs = [raw];
        }

        errorHandler.errorDescription.errors = msgs;
        errorHandler.errorNumber = data?.statusCode || res?.status || 0;
        formLoad.value = false;
      })

    } else {

      // Create
      await post(path, form).then(() => {

        Modal.success({
          title: `¡El registro se ha almacenado exitosamente!`,
        })
        closeModal()
        formLoad.value = false

      }).catch((error) => {
        // It supports normalised or pure Axios errors
        const res = error?.response;
        const data = res?.data;

        let msgs = [];

        // 1) If it comes already normalized as Error with .message (without response)
        if (error?.message && !res) {
          msgs = [String(error.message)];
        } else if (Array.isArray(data?.message)) {
          msgs = data.message.map(m => String(m)).filter(Boolean);
        } else if (typeof data?.message === 'string') {
          msgs = [data.message];
        } else if (typeof data === 'string') {
          msgs = [data];
        }

        // Fallback if we couldn't extract anything
        if (!msgs.length) {
          const raw = error?.message || 'Ocurrió un error al procesar la solicitud.';
          msgs = [raw];
        }

        errorHandler.errorDescription.errors = msgs;
        errorHandler.errorNumber = data?.statusCode || res?.status || 0;
        formLoad.value = false;
      })
    }

    await getBusinessUnits(10, 0)
  }

  const deleteRecord = async () => {

    const path = apiRoutes.businessUnit
    const response = await softDelete(path, formId.value)
    if (response) {
      formId.value = ''
      await getBusinessUnits(10, 0)
    }

  }

  return {
    searchText,
    visible,
    visiblePlants,
    formId,
    form,
    formLoad,
    rules,
    businessUnits,
    plants,
    selectBusinessUnits,
    tableLoading,
    plantsLoading,
    errorHandler,
    ruleForm,

    paginatorTotalItems,
    paginatorTotalPages,
    paginatorCurrentPage,
    onChangePaginator,

    openPlantsModal,
    closePlantsModal,
    openModal,
    closeModal,
    getBusinessUnits,
    getBusinessUnitsNoPaginate,
    submit,
    deleteRecord,

    eventOpenModal,
    eventOpenPlantsModal,
    eventSoftDelete,
  }
}

export default useBusinessUnit

